var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnitsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.90009,
    y: 1.89999,
    width: 10.2,
    height: 10.2,
    rx: 2.5,
    stroke: "#6E7882"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20001 4.89999C4.20001 4.70669 4.35671 4.54999 4.55001 4.54999H8.05001C8.24331 4.54999 8.40001 4.70669 8.40001 4.89999C8.40001 5.09329 8.24331 5.24999 8.05001 5.24999H4.55001C4.35671 5.24999 4.20001 5.09329 4.20001 4.89999ZM4.20001 6.99999C4.20001 6.80669 4.35671 6.64999 4.55001 6.64999H8.75001C8.94331 6.64999 9.10001 6.80669 9.10001 6.99999C9.10001 7.19329 8.94331 7.34999 8.75001 7.34999H4.55001C4.35671 7.34999 4.20001 7.19329 4.20001 6.99999ZM4.55001 8.74999C4.35671 8.74999 4.20001 8.90669 4.20001 9.09999C4.20001 9.29329 4.35671 9.44999 4.55001 9.44999H9.45001C9.64331 9.44999 9.80001 9.29329 9.80001 9.09999C9.80001 8.90669 9.64331 8.74999 9.45001 8.74999H4.55001Z",
    fill: "#6E7882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnitsOutline);
export default __webpack_public_path__ + "static/media/icon-units-outline.7c4b3bd4056723d6c6b114d099247839.svg";
export { ForwardRef as ReactComponent };